import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  currentUser: JSON.parse(localStorage.getItem("user")) || "",
  token: localStorage.getItem("token") || "",
  //permisosList: JSON.parse(localStorage.getItem("user.all_permissions")) || "",
};
export const mutations = {
  AUTH_SUCCESS({ context }, payload) {
    state.loading = false;
    state.token = payload.token;
    state.currentUser = Object.assign({}, payload.user);
    //state.permisosList = Object.assign({}, payload.user.all_permissions);
    localStorage.setItem("token", state.token);
    localStorage.setItem("user", JSON.stringify(state.currentUser));
    // localStorage.setItem("permisosList", JSON.stringify(state.permisosList));
    axios.defaults.headers.common["Authorization"] = "Bearer " + state.token;
  },
  AUTH_LOGOUT(state, rootState) {
    state.loading = false;
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("solicitud_refrendo");
    delete axios.defaults.headers.common["Authorization"];
    state.token = "";
    state.currentUser = {};
  },
  AUTH_SYNC(state, user) {
    // Sobreescribe el state de Vuex con los datos reales del servidor.
    // Se llama desde DashboardLayout.mounted() después de /me.
    state.currentUser = Object.assign({}, user);
    localStorage.setItem("user", JSON.stringify(user));
  }
};
export const actions = {
  LOGIN({ commit }, credentials) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.login(credentials)
        .then(response => {
          commit("SET_LOADING", false);
          commit("CLEAR_NOTIFICATION");
          commit("AUTH_SUCCESS", response.data);
          commit("SET_NOTIFICATION", {
            tipo: "success",
            message: response.data.message
          });
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          commit("AUTH_LOGOUT");
          reject(error);
        });
    });
  },
  LOGOUT({ commit, state }) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      // ApiService.logout({ data: { token: localStorage.getItem('token') } })
      ApiService.logout({ data: { token: state.token } })
        .then(response => {
          commit("SET_LOADING", false);
          commit("CLEAR_NOTIFICATION");
          commit("AUTH_LOGOUT");
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  ACTUALIZAR_PASSWORD({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.put(data)
        .then(response => {
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  }
};
export const getters = {
  isLoggedIn: state => !!state.token,
  currentUser: state => state.currentUser,
  roleUser: state => state.currentUser.roles[0].id || false,
  permisosList: state => state.currentUser.all_permissions || [{0:{name:'no_login'}}]
};
